document.addEventListener('DOMContentLoaded', function () {
  var customerMessagesSwiper = document.querySelector('.customer__messages--area');
  if(customerMessagesSwiper) {
    const customerSwiper = new Swiper(customerMessagesSwiper, {
      slidesPerView: 1.05,
      spaceBetween: 8,
      pagination: {
        el: '.customer-message-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      }
    });
  }
});

// Product page: keep the sticky gallery (custom-islamic.css, >=990px) clear of
// the sticky site header. The header is fixed (.site-header--stuck) once its
// slot scrolls away and only on screen while .site-header--opening is set
// (scrolling up; theme.js scrollHandler), so the offset follows both classes.
document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('.grid--product-images--partial');
  var header = document.querySelector('.site-header');
  if (!grid || !header) return;

  function setStickyTop() {
    var shown = header.hasAttribute('data-sticky-always') ||
      (header.classList.contains('site-header--stuck') &&
        header.classList.contains('site-header--opening'));
    var offset = shown ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--iwa-sticky-top', Math.round(offset + 20) + 'px');
  }

  setStickyTop();
  new MutationObserver(setStickyTop).observe(header, { attributes: true, attributeFilter: ['class'] });
  if (window.ResizeObserver) new ResizeObserver(setStickyTop).observe(header);
});
